import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes, Route } from '@angular/router';
import { GlobalModule, CsrfService } from '@argalis-apps/angular-global';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { PopupModule } from '@progress/kendo-angular-popup';
import { AuthRouting } from './auth-routing';
import { AuthHomeButtonComponent } from './components/auth-home-button/auth-home-button.component';
import { ConnexionComponent } from './components/connexion/connexion.component';
import { InscriptionComponent } from './components/inscription/inscription.component';
import { RenewPasswordComponent } from './components/renew-password/renew-password.component';
import { AuthService } from './services/auth/auth.service';
import { AuthConfigService, AuthConfigServiceOption } from './services/auth-config/auth-config.service';
import { InscriptionService } from './services/inscription/inscription.service';
import { DeconnexionComponent } from './components/deconnexion/deconnexion.component';
import { WindowModule } from '@progress/kendo-angular-dialog';
import { SuccessInscriptionComponent } from './components/success-inscription/success-inscription.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { IconsModule } from '@progress/kendo-angular-icons';

@NgModule({
  declarations: [
    AuthHomeButtonComponent,
    ConnexionComponent,
    InscriptionComponent,
    RenewPasswordComponent,
    DeconnexionComponent,
    SuccessInscriptionComponent,
    ChangePasswordComponent
  ],
  imports: [
    CommonModule,
    GlobalModule,
    ButtonsModule,
    DateInputsModule,
    DropDownsModule,
    FormsModule,
    InputsModule,
    PopupModule,
    ReactiveFormsModule,
    RouterModule,
    WindowModule,
    IconsModule
  ],
  exports: [
    CommonModule,
    AuthHomeButtonComponent,
    ConnexionComponent,
    InscriptionComponent,
    RenewPasswordComponent,
    DeconnexionComponent,
    ChangePasswordComponent
  ],
  providers: [AuthService, AuthConfigService, InscriptionService, CsrfService]
})
export class AuthModule {
  public static moduleRouting(config?: AuthConfigServiceOption): Routes {
    return AuthRouting.filter((route: Route) => {
      if (!config.accountCreation && route.path === 'signup') return false;
      return true;
    });
  }

  public static forRoot(config?: AuthConfigServiceOption): ModuleWithProviders<AuthModule> {
    return {
      ngModule: AuthModule,
      providers: [
        AuthService,
        AuthConfigService,
        InscriptionService,
        CsrfService,
        {
          provide: AuthConfigServiceOption,
          useValue: config
        }
      ]
    };
  }
}
